import { render, staticRenderFns } from "./datatable-information-dropdown.component.vue?vue&type=template&id=28696bab&"
import script from "./datatable-information-dropdown.component.vue?vue&type=script&lang=ts&"
export * from "./datatable-information-dropdown.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports